import Swal from "sweetalert2";

export const successAlert = (title, message) => Swal.fire(title, message, "success");
export const errorAlert = (title, message) => Swal.fire(title, message, "error");